/**
 * Merges directory entries (members or teams) loaded for different scopes into a
 * single deduplicated list.
 *
 * Lists are visited in order and the first entry for a given id wins.
 */
export const mergeDirectoryEntries = <T>(
  lists: ReadonlyArray<readonly T[]>,
  getId: (entry: T) => string,
): T[] => {
  const seen = new Set<string>();

  return lists.reduce<T[]>((merged, entries) => {
    for (const entry of entries) {
      const id = getId(entry);
      if (!seen.has(id)) {
        seen.add(id);
        merged.push(entry);
      }
    }
    return merged;
  }, []);
};
